<template>
  <div>
    <!-- -->
  </div>
</template>

<script>
export default {
  name: "WorkspaceJsonIndex",

  data() {
    return {};
  },

  mounted() {
    var allData = {
      citys: [
        {
          name: "浙江",
          value: [120.152792, 30.267447, 2],
          symbolSize: 20,
          itemStyle: {
            normal: {
              color: "red",
            },
          },
        },
        {
          name: "珠海",
          value: [113.576726, 22.270715, 9],
          symbolSize: 10,
          itemStyle: {
            normal: {
              color: "#2a333d",
            },
          },
        },
        {
          name: "齐齐哈尔",
          value: [104.250711, 30.88682, 1],
          symbolSize: 10,
          itemStyle: {
            normal: {
              color: "green",
            },
          },
        },
      ],
      moveLines: [
        {
          fromName: "黑龙江",
          toName: "浙江",
          coords: [
            [104.250711, 30.88682],
            [120.152792, 30.267447],
          ],
        },
        {
          fromName: "珠海",
          toName: "浙江",
          coords: [
            [113.576726, 22.270715],
            [120.152792, 30.267447],
          ],
        },
        {
          fromName: "黑龙江",
          toName: "浙江",
          coords: [
            [104.250711, 30.88682],
            [120.152792, 30.267447],
          ],
        },
        {
          fromName: "黑龙江",
          toName: "浙江",
          coords: [
            [104.250711, 30.88682],
            [120.152792, 30.267447],
          ],
        },
      ],
    };
    option = {
      backgroundColor: "#404a59",
      title: {
        text: "朴姓人口迁徙图",
        left: "center",
        textStyle: {
          color: "#fff",
        },
      },
      legend: {
        show: false,
        orient: "vertical",
        top: "bottom",
        left: "right",
        data: ["地点", "线路"],
        textStyle: {
          color: "#fff",
        },
      },
      geo: {
        map: "china",
        label: {
          emphasis: {
            show: true,
            color: "#fff",
          },
        },
        roam: true,
        itemStyle: {
          //   areaColor: 'red',
          areaColor: {
            image:
              "https://shituoshili-dev-001.oss-cn-hangzhou.aliyuncs.com/test/2025-04-18/c53102883b0645f78abd294b2c63399d.png", // 支持 base64 或网络图片
            repeat: "no-repeat",
            x: -180, // 水平偏移调整
            y: -240, // 可选: 'repeat-x' | 'repeat-y' | 'no-repeat'
          },

          color: "purple",
          borderColor: "rgba(255,255,255,0.6)",
          borderWidth: 2,
          shadowColor: "rgba(255,255,255,0.6)",
          emphasis: {
            areaColor: "#4d3c1c",
            borderColor: "rgba(255,255,255,0.5)",
            borderWidth: 3,
          },
        },
      },
      series: [
        {
          name: "地点",
          type: "effectScatter",
          coordinateSystem: "geo",
          zlevel: 2,
          rippleEffect: {
            brushType: "stroke",
          },
          label: {
            emphasis: {
              show: true,
              position: "right",
              formatter: "{b}",
            },
          },
          symbolSize: 2,
          showEffectOn: "render",
          itemStyle: {
            normal: {
              color: "#46bee9",
            },
          },
          data: allData.citys,
        },
        {
          name: "线路",
          type: "lines",
          coordinateSystem: "geo",
          zlevel: 2,
          large: true,
          effect: {
            show: true,
            symbol: "arrow",
            symbolSize: 5,
            period: 3,
            trailLength: 0.02,
          },
          lineStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 0,
                    color: "#58B3CC",
                  },
                  {
                    offset: 1,
                    color: "#F58158",
                  },
                ],
                false
              ),
              width: 1,
              opacity: 0.2,
              curveness: 0.1,
            },
          },
          data: allData.moveLines,
        },
      ],
    };
  },

  methods: {},
};
</script>
<style lang="scss" scoped></style>
